module.exports = __webpack_public_path__ + "img/jump.be5030ca.webp";